import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});


export function errorMessage(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export async function startCheckout(plan) {
  const { data } = await api.post("/payments/checkout", { plan, origin_url: window.location.origin });
  window.location.href = data.checkout_url;
}

export async function openBillingPortal() {
  const { data } = await api.post("/payments/portal", { origin_url: window.location.origin });
  window.location.href = data.url;
}
